import { createSlice } from '@reduxjs/toolkit';
import { getWinnersList, publishWinnerInfo } from './winnersService';

const initialState = {
    winnersList: {
        isWinnersLoading: null,
        isWinnersSuccess: null,
        pageCount: 0,
        winners: [],
    },
    pubslishWinnerDetails: {
        isWinnerPublishing: null,
        isPublishSuccess: null,
        winnerDetails: [],
    },
};

const winnersSlice = createSlice({
    name: 'winner',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getWinnersList.pending, (state) => {
            state.winnersList = {
                ...initialState.winnersList,
                isWinnersLoading: true,
            };
        });

        builder.addCase(getWinnersList.rejected, (state) => {
            state.winnersList = {
                ...initialState.winnersList,
                isWinnersLoading: false,
                isWinnersSuccess: false,
            };
        });

        builder.addCase(getWinnersList.fulfilled, (state, action) => {
            state.winnersList = {
                ...initialState.winnersList,
                isWinnersLoading: false,
                isWinnersSuccess: true,
                pageCount: action.payload.pageCount || 0,
                winners: action.payload.data || [],
            };
        });

        //Winner publish
        builder.addCase(publishWinnerInfo.pending, (state) => {
            state.pubslishWinnerDetails = {
                ...initialState.pubslishWinnerDetails,
                isWinnerPublishing: true,
            };
        });

        builder.addCase(publishWinnerInfo.rejected, (state) => {
            state.pubslishWinnerDetails = {
                ...initialState.pubslishWinnerDetails,
                isWinnerPublishing: false,
                isPublishSuccess: false,
            };
        });

        builder.addCase(publishWinnerInfo.fulfilled, (state, action) => {
            state.pubslishWinnerDetails = {
                ...initialState.pubslishWinnerDetails,
                isWinnerPublishing: false,
                isPublishSuccess: true,
                winnerDetails: action.payload.data || [],
            };
        });
    },
});

export default winnersSlice.reducer;
